/* eslint-disable react/jsx-props-no-spreading */
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import AllBranchesModal from '../Modals/AllBranchesModal/AllBranchesModal';
import BranchesLogModal from '../Modals/BranchesLogModal/BranchesLogModal';
import WorkingHoursLogModal from '../Modals/WorkingHoursLogModal/WorkingHoursLogModal';
import BranchesModal from '../Modals/BranchesModal/BranchesModal';
import CategoryAndProductModal from '../Modals/CategoryAndProductModal/CategoryAndProductModal';
import { CategoryItemsModal } from '../Modals/CategoryItemsModal/CategoryItemsModal';
import { CategoryMenuGroupsModal } from '../Modals/CategoryMenuGroupsModal/CategoryMenuGroupsModal';
import CrossSellingModal from '../Modals/CrossSellingModal/CrossSellingModal';
import CustomerWalletModal from '../Modals/CustomerWalletModal/CustomerWalletModal';
import CustomersModal from '../Modals/CustomersModal/CustomersModal';
import DeliveryRequestInfoModal from '../Modals/DeliveryRequestInfoModal/DeliveryRequestInfoModal';
import ItemsForDealModal from '../Modals/ItemsForDealModal/ItemsForDealModal';
import ModifierAndExclusionModal from '../Modals/ModifierAndExclusionModal/ModifierAndExclusionModal';
import UpdateModal from '../Modals/UpdateModal';
import WeekModal from '../Modals/WeekModal/WeekModal';
import PauseDeliveryModal from '../Modals/PauseDeliveryModal/PauseDeliveryModal';
import { TimeConfirmModal } from '../Modals/TimeConfirmModal/TimeConfirmModal';
import ToYouMatchBranchesModal from '../Modals/ToYouMatchBranchesModal/ToYouMatchBranchesModal';
// eslint-disable-next-line max-len
import { T360LastSyncErrorsModal } from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/containers/T360LastSyncErrorsModal/T360LastSyncErrorsModal';
import { modalStore } from 'src/mobx/modalStore';
import BranchLocationModal from 'src/view/containers/Modals/BranchLocationModal/BranchLocationModal';
import DeliveryTrackingModal from 'src/view/containers/Modals/DeliveryTrackingModal/DeliveryTrackingModal';
import DineInSectionModal from 'src/view/containers/Modals/DineInSectionModal/DineInSectionModal';
import MenuGroupItemModal from 'src/view/containers/Modals/MenuGroupItemModal/MenuGroupItemModal';
import { OrderProductModal } from 'src/view/containers/Modals/OrderProductModal/OrderProductModal';
import WorkingHoursModal from 'src/view/containers/Modals/WorkingHoursModal/WorkingHoursModal';
import DeliveryTypeScreen from 'src/view/screens/DeliveryTypeScreen/DeliveryTypeScreen';
import { AskAgainModal } from '~/view/containers/Modals/AskAgainModal/AskAgainModal';
import ErrorModal from '~/view/containers/Modals/ErrorModal';
import { MealChoiceEditModal } from '~/view/containers/Modals/MealChoiceEditModal';
import { MealGroupEditModal } from '~/view/containers/Modals/MealGroupEditModal';
import { MealItemEditModal } from '~/view/containers/Modals/MealItemEditModal';
import { MealItemMdfExclModal } from '~/view/containers/Modals/MealItemMdfExclModal';
import { MealSizeEditModal } from '~/view/containers/Modals/MealSizeEditModal';
import { PreviousOrderModal } from '~/view/containers/Modals/PreviousOrderModal';
import './style.scss';
import { NutrientsModal } from '~/view/containers/Modals/NutrientsModal/NutrientsModal';
import T360BranchesMapping from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360BranchesMapping/T360BranchesMapping';
import { T360BranchesMappingModal } from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/containers/T360BranchesMappingModal/T360BranchesMappingModal';
import { NoticeModal } from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/containers/NoticeModal/NoticeModal';

@observer
export default class ModalsContainer extends Component<{}, {}> {
  render() {
    return (
      <React.Fragment>
        {modalStore.errorModal.length ? (
          <ErrorModal {...modalStore.errorModal[0]} />
        ) : modalStore.orderProduct ? (
          <OrderProductModal />
        ) : modalStore.deliveryType ? (
          <DeliveryTypeScreen />
        ) : modalStore.customersModal ? (
          <CustomersModal />
        ) : modalStore.categoryAndProductModal ? (
          <CategoryAndProductModal />
        ) : modalStore.nutrientsModal ? (
          <NutrientsModal />
        ) : modalStore.modifierAndExclusionModal ? (
          <ModifierAndExclusionModal />
        ) : modalStore.allBranchesModal ? (
          <AllBranchesModal />
        ) : modalStore.branchesModal ? (
          <BranchesModal />
        ) : modalStore.previousOrderModal ? (
          <PreviousOrderModal {...modalStore.previousOrderModal} />
        ) : modalStore.weekModal ? (
          <WeekModal />
        ) : modalStore.categoryItemsModal ? (
          <CategoryItemsModal />
        ) : modalStore.categoryMenuGroupsModal ? (
          <CategoryMenuGroupsModal />
        ) : modalStore.crossSellingModal ? (
          <CrossSellingModal />
        ) : modalStore.deliveryTrackingModal ? (
          <DeliveryTrackingModal />
        ) : modalStore.deliveryRequestInfoModal ? (
          <DeliveryRequestInfoModal />
        ) : modalStore.itemsForDealModal ? (
          <ItemsForDealModal />
        ) : modalStore.mealSizeEditModal ? (
          <MealSizeEditModal {...modalStore.mealSizeEditModal} />
        ) : modalStore.mealGroupEditModal ? (
          <MealGroupEditModal {...modalStore.mealGroupEditModal} />
        ) : modalStore.mealChoiceEditModal ? (
          <MealChoiceEditModal {...modalStore.mealChoiceEditModal} />
        ) : modalStore.mealItemEditModal ? (
          <MealItemEditModal {...modalStore.mealItemEditModal} />
        ) : modalStore.menuGroupItemModal ? (
          <MenuGroupItemModal />
        ) : modalStore.branchLocationModal ? (
          <BranchLocationModal />
        ) : modalStore.dineInSectionModal ? (
          <DineInSectionModal />
        ) : modalStore.workingHoursModal ? (
          <WorkingHoursModal />
        ) : modalStore.customerWalletModal ? (
          <CustomerWalletModal />
        ) : modalStore.updateModal ? (
          <UpdateModal />
        ) : modalStore.branchesLogModal ? (
          <BranchesLogModal />
        ) : modalStore.workingHoursLogModal ? (
          <WorkingHoursLogModal />
        ) : modalStore.pauseDeliveryModal ? (
          <PauseDeliveryModal />
        ) : modalStore.toYouMatchBranchesModal ? (
          <ToYouMatchBranchesModal />
        ) : modalStore.timeConfirmModal ? (
          <TimeConfirmModal />
        ) : modalStore.t360SyncErrorsModal ? (
          <T360LastSyncErrorsModal />
        ) : modalStore.t360BranchesMappingModal ? (
          <T360BranchesMappingModal />
        ) : null}

        {modalStore.noticeModal && <NoticeModal />}
        {modalStore.askAgainModal && <AskAgainModal {...modalStore.askAgainModal} />}
        {modalStore.mealItemMdfExclModal && <MealItemMdfExclModal {...modalStore.mealItemMdfExclModal} />}
      </React.Fragment>
    );
  }
}
